import React, {memo} from 'react';
import {ChartOptions} from "chart.js";
import {Line} from "react-chartjs-2";
import {formatNumber, roundNumber} from "../../../../components/helpers";

const LineChart = memo((
  {
    month,
    total,
    totalVH,
    step = 10,
    isPercent = true,
    height,
    fontSize = 11,
    displayDataLabel = true
  }: {
    month: string[],
    total: any,
    totalVH?: any,
    step?: number,
    isPercent?: boolean,
    height?: any,
    fontSize?: number,
    displayDataLabel?: boolean,
  }
) => {
  const moyenneData = (isPercent && totalVH?.length > 0) ? total?.map((value, key: number) => {
    const moyenne = ((value / totalVH?.[key]) * 100) || 0;
    return moyenne < 0 ? 0 : moyenne;
  }) || [] : total?.map((value) => {
    return value < 0 ? 0 : value;
  });

  const lineData = {
    labels: (month.length > 0 && month.length === 1) ? ['', month[0], ''] : (month.length > 0 && month.length > 1) ? month : [],
    datasets: [
      {
        data: (moyenneData.length > 0 && moyenneData.length === 1) ? [null, moyenneData[0], null] : (moyenneData.length > 0 && moyenneData.length > 1) ? moyenneData : [],
        borderColor: "#FF3342FF",
      },
    ],
  };

  const lineOptions: ChartOptions<any> = {
    maintainAspectRatio: false,
    responsive: true,
    layout: {
      padding: {
        left: 20,
        right: 20,
        top: 15,
      },
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: fontSize
          }
        },
        stacked: true,
        grid: {
          display: false
        }
      },
      y: {
        beginAtZero: true,
        ticks: {
          font: {
            size: fontSize
          },
          stepSize: step,
          callback: function (value: number) {
            return isPercent ? this?.getLabelForValue(value) + ' %' : this?.getLabelForValue(value) + ' j';
          },
        }
      }
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        position: 'nearest',
        callbacks: {
          label: function (items) {
            const value = isPercent ? roundNumber(items?.raw) : formatNumber(items?.raw);
            return `${value} ${isPercent ? '%' : 'j'}`;
          }
        }
      }
    },
  };

  const barValuePlugin = {
    id: 'barValuePlugin',
    afterDatasetsDraw: (chart) => {
      if (!displayDataLabel) return;
      const {ctx, data} = chart;
      data.datasets.forEach((dataset, datasetIndex) => {
        const meta = chart.getDatasetMeta(datasetIndex);
        meta.data.forEach((bar, index) => {
          const value = dataset.data[index] || 0;
          ctx.save();
          ctx.textAlign = 'center';
          ctx.textBaseline = 'bottom';
          ctx.fillStyle = "#b91826";
          ctx.font = `small ${fontSize}px Arial`;
          ctx.fillText(value !== 0 ? `${isPercent ? roundNumber(value) : formatNumber(value)} ${isPercent ? '%' : 'j'}` : '', bar.x, bar.y + 1);
          ctx.restore();
        });
      });
    }
  };

  return <Line data={lineData} options={lineOptions} height={height} plugins={[barValuePlugin]}/>;
});

export default LineChart;